var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('div',_vm._g(_vm._b({staticClass:"CareIcon",class:_vm.data.staticClass,style:({ backgroundColor: _vm.props.careType.color })},'div',Object.assign({}, _vm.data.attrs, ( _obj = {}, _obj[_vm.parent.$options._scopeId] = '', _obj )),false),_vm.listeners),[_c('div',{staticClass:"img-wrap"},[_c('img',{attrs:{"src":("/images/care/" + (_vm.props.careType.image)),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }